import { deepMerge } from 'js/utils/Utils'
const defaults = {
  flagKey: 'hasLoadedOnce',
  onLoad: null, // 初回限定アニメーション
  onSkip: null, // 2回目以降の処理（任意）
}

export default class OpeningLoader {
  options = {}
  constructor(options = {}) {
    this.options = deepMerge(this.options, defaults, options)
    this.flagKey = this.options.flagKey
  }

  /**
   * フラグが未設定＝初回であれば true を返す
   */
  shouldRun() {
    return !sessionStorage.getItem(this.flagKey)
  }

  /**
   * アニメーション完了後に呼び出してフラグを記録
   */
  markAsDone() {
    sessionStorage.setItem(this.flagKey, 'true')
  }

  /**
   * 初回だけアニメーションを実行し、フラグを保存する
   */
  async init() {
    if (this.shouldRun()) {
      if (typeof this.options.onLoad === 'function') {
        await this.options.onLoad()
      }
      this.markAsDone()
    } else {
      if (typeof this.options.onSkip === 'function') {
        this.options.onSkip()
      }
    }
  }

  /**
   * フラグを手動でリセット
   */
  reset() {
    sessionStorage.removeItem(this.flagKey)
  }

  /**
   * セッションストレージ全体を削除（注意）
   */
  clear() {
    sessionStorage.clear()
  }
}